;(function ($, undefined) {
    'use strict';

    var rnn = window.rnn,
        log = rnn.logging.log,
        $newsflash;

    function showNextNewsflash() {
        var $newsflashItems = $newsflash.find('.newsflash-item');

        if ($newsflashItems.length > 0) {
            $newsflashItems.each(function (){
                var $newsflashItem, id, cookieName, cookieOptions, cookieValue;

                $newsflashItem = $(this);
                cookieName = $newsflashItem.attr('id') + '-closed';
                cookieOptions = {
                    expires: new Date($newsflashItem.data('expires')),
                    path: '/'
                };
                $newsflashItem.on('click', '.close', function () {
                    $newsflashItem.hide();
                    Cookies.set(cookieName, "1", cookieOptions);
                    showNextNewsflash();
                });
                cookieValue = Cookies.get(cookieName);
                if (!cookieValue) {
                    $(this).show();
                    return false;
                }
            });
        } else {
            $newsflash.remove();
        }
    }

    function initNewsflashes() {
        $newsflash = $('#newsflash');
        if ($newsflash.length) {
            var newsFlashURL = rnn.site.newsFlashURL;
            if (newsFlashURL) {
                $newsflash.load(newsFlashURL, showNextNewsflash);
            }
        }
    }

    rnn.modules.register("newsflashes", {
        init: initNewsflashes
    });

})(jQuery);
